/**
 * API utility functions for communicating with Python backend
 */

import axios from 'axios'

const API_BASE_URL = import.meta.env.VITE_API_URL || '/api'

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Contact API
export const submitContact = async (formData) => {
  try {
    const response = await api.post('/contact', formData)
    return response.data
  } catch (error) {
    throw new Error(error.response?.data?.error || 'Failed to submit contact form')
  }
}

// Testimonials API
export const getTestimonials = async () => {
  try {
    const response = await api.get('/testimonials')
    return response.data
  } catch (error) {
    console.error('Error fetching testimonials:', error)
    return { success: false, testimonials: [] }
  }
}

// Stats API
export const getStats = async () => {
  try {
    const response = await api.get('/stats')
    return response.data
  } catch (error) {
    console.error('Error fetching stats:', error)
    return { success: false, stats: null }
  }
}

// Health check
export const checkHealth = async () => {
  try {
    const response = await api.get('/health')
    return response.data
  } catch (error) {
    console.error('Backend health check failed:', error)
    return { status: 'unhealthy' }
  }
}

export default api

